import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Message } from '../../services/message/message'
import { MessageType } from '../../services/message/message-type'
import { MessageService } from '../../services/message/message.service'

@Component({
  selector: 'gpei-toast-stack',
  templateUrl: 'toast-stack.component.html',
  styleUrls: [ 'toast-stack.component.sass' ],
  standalone: true,
  imports: [
    CommonModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ToastStackComponent {

  private readonly _message = inject(MessageService)

  /**
   *
   * @param value
   */
  onDismiss(value: Message): void {
    this._message.remove(value)
  }

  /**
   *
   */
  get toasts$(): Observable<Message[]> {
    return this._message
      .messages$
      .pipe(
        map(it => it.filter(message => message.type === MessageType.TOAST))
      )
  }
}
